import Vue from 'vue'
import VueTouch from 'vue-touch'
Vue.use(VueTouch)



// WEBPACK FOOTER //
// ./src/plugin-config/v-touch.js